import Vue from "vue";
import { mapir, mapNavigationControl, mapGeolocateControl, mapMarker, mapPopup } from "mapir-vue";
// import MapirDirections from 'mapir-vue/src/components/MapirDirections.vue';

Vue.use(mapir,{
  layerStyle: 'Hybrid',
});
Vue.use(mapNavigationControl);
Vue.use(mapGeolocateControl);
Vue.use(mapPopup);
Vue.use(mapMarker);
// Vue.use(MapirRouter);
Vue.component('mapir', mapir);
Vue.component('mapNavigationControl', mapNavigationControl);
Vue.component('mapGeolocateControl', mapGeolocateControl);
Vue.component('mapMarker', mapMarker);
Vue.component('mapPopup', mapPopup);
// Vue.component('mapDirection', MapirRouter);
